module.exports = __webpack_public_path__ + "img/complife-group-logo-xl.9044b406.jpg";